<template>
  <div style="display:none" v-show="(social && social.length || (hiddenLogin && !isMobile))">
    <div id="floatButtons">
      <SfButton v-if="hiddenLogin" class="sf-cart" aria-label="Toggle cart sidebar" @click="toggleCartSidebar">
        <SfIcon class="sf-header__icon" icon="empty_cart" size="1.25rem" />
        <SfBadge v-if="cartTotalItems" class="sf-badge--number cart-badge">{{ cartTotalItems }}</SfBadge>
      </SfButton>
      <SfImage class="footer__social-image" v-for="(item, key) in social" v-if="item.type == '1'" :key="key"
        :src="addBasePath('/icons/' + item.iso + '.svg')" :alt="item.iso" :width="32" :height="32"
        @click="openLink(item.link)" />
    </div>
  </div>
</template>
<script>
import { SfMenuItem, SfImage, SfIcon, SfButton, SfBadge } from "@storefront-ui/vue";
import { computed } from "@nuxtjs/composition-api";
import { addBasePath } from "@vue-storefront/core";
import { useOCart, cartGetters } from "@bee-hole/coms";
import { useUiState } from "~/composables";

export default {
  name: 'floatButtons',
  components: {
    SfMenuItem,
    SfImage,
    SfIcon,
    SfButton,
    SfBadge
  },
  setup(props, context) {
    const { cart } = useOCart();
    const {
      toggleCartSidebar,
      isMobile
    } = useUiState();
    const social = computed(() => {
      const list = [];
      let list1 = [];
      if (!context?.root?.$options?.$storeConfig?.mall_home_type || context?.root?.$options?.$storeConfig?.mall_home_type === 'default') {
        list1 = context?.root?.$options?.$mallConfig?.mall_zx_home?.Social;
      } else {
        list1 = context?.root?.$options?.$mallConfig?.mall_home_artice?.Sociall;
      }
      list1?.map(item => {
        if (item.type === '1') list.push(item);
      });
      return list;
    });
    const openLink = (link) => {
      if (link) {
        window.open(link, "_blank");
      }
    };
    const cartTotalItems = computed(() => {
      const count = cartGetters.getTotalItems(cart.value);
      return count ? count.toString() : null;
    });
    const hiddenLogin = computed(() => {
      return !context?.root?.$options?.$mallConfig?.mall_web_config?.hidden_login;
    });
    return {
      social,
      openLink,
      addBasePath,
      cartTotalItems,
      toggleCartSidebar,
      isMobile,
      hiddenLogin
    };
  }
};
</script>
<style lang="scss" scoped>
.floatHidden {
  display: none;
}

#floatButtons {
  width: 3rem;
  padding: 0.5rem;
  position: fixed;
  right: 1rem;
  top: 45vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgb(193, 193, 193, 0.5);
  z-index:999999999;

  .sf-cart {
    background: rgb(193, 193, 193, 1);
    border-radius: 15px;
    padding: 5px;
    display: block;
    position: relative;
    width: 2rem;
    @include for-mobile{
      display: none !important;
    }
    .sf-badge--number {
      position: absolute;
      left: -0.5rem;
      top: -0.5rem;
    }
  }

  .footer__social-image {
    margin-top: 10px;
    border-radius: 15px;
    display: block;
  }
}
</style>
